@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Brand Header -->
<div
  class="relative mb-4 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div class="flex items-center justify-between px-5 py-1 relative">
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0 && clntDtls[0].clnt_id==7) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          Trip Wise Coverage Status
        </h1>
        } @if (selectedtenantNm) {
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            {{ selectedtenantNm }} - {{ selectedSvm }}
          </p>
        </div>
        }
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center" style="gap: 8px">
      <!-- Date Picker -->
      <div class="flex flex-col min-w-0">
        <label style="font-size: 12px; font-weight: 600; color: #64748b"
          >Date:</label
        >
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          style="border-radius: 6px; width: 150px"
        ></nz-date-picker>
      </div>

      <!-- Vehicle Select (multiple vehicles) -->
      @if (vehclesLst.length>1) {
      <div class="flex flex-col min-w-0" style="min-width: 200px">
        <label style="font-size: 12px; font-weight: 600; color: #64748b"
          >Vehicle:</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Please Select Vehicle"
          (ngModelChange)="onasrtgetSelected($event)"
          [(ngModel)]="selectedVehicle"
          style="border-radius: 6px"
        >
          @for (a of vehclesLst; track a) {
          <nz-option [nzValue]="a.asrt_id" [nzLabel]="a.asrt_nm"> </nz-option>
          }
        </nz-select>
      </div>
      }

      <!-- Vehicle Select (single vehicle) -->
      @if (vehclesLst.length==1) {
      <div class="flex flex-col min-w-0">
        <label style="font-size: 12px; font-weight: 600; color: #64748b"
          >Vehicle:</label
        >
        <span class="font-semibold" style="font-size: 12px; color: #0f766e">{{
          vehclesLst[0].asrt_nm
        }}</span>
      </div>
      }

      <!-- Go Back Button -->
      <button
        (click)="goBack()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <svg
          style="width: 14px; height: 14px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 17l-5-5m0 0l5-5m-5 5h12"
          ></path>
        </svg>
        Go Back
      </button>
    </div>
  </div>
</div>

<!-- Summary Strip -->
@if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
<div class="cvrg-summary-strip">
  <!-- Total Vehicles -->
  @for (d of tdyCoveredTrips; track d) {
  <div class="cvrg-summary-card cvrg-border-indigo">
    <div class="cvrg-card-body">
      <div class="cvrg-card-info">
        <div class="cvrg-summary-value">
          {{ d.TOT_VEHICLES === null ? "0" : d.TOT_VEHICLES }}
        </div>
        <span class="cvrg-summary-label">Total Vehicles</span>
      </div>
      <div class="cvrg-summary-icon bg-indigo">
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
          ></path>
        </svg>
      </div>
    </div>
  </div>
  }
  <!-- Operated / Total Trips -->
  @for (d of tdyCoveredTrips; track d) {
  <div class="cvrg-summary-card cvrg-border-amber">
    <div class="cvrg-card-body">
      <div class="cvrg-card-info">
        <div class="cvrg-summary-value">
          {{ d.OPERATED === null ? "0" : d.OPERATED }} /
          {{ d.TOTAL_TRIPS === null ? "0" : d.TOTAL_TRIPS }}
          <span class="cvrg-summary-pct">({{ d.op_per }} %)</span>
        </div>
        <span class="cvrg-summary-label">Operated / Total Trips</span>
      </div>
      <div class="cvrg-summary-icon bg-amber">
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
          ></path>
        </svg>
      </div>
    </div>
  </div>
  }
  <!-- Route Deviated -->
  @for (d of tdyCoveredTrips; track d) {
  <div class="cvrg-summary-card cvrg-border-rose">
    <div class="cvrg-card-body">
      <div class="cvrg-card-info">
        <div class="cvrg-summary-value">
          {{ d.ROUTE_DEVIATED === null ? "0" : d.ROUTE_DEVIATED }}
        </div>
        <span class="cvrg-summary-label">Route Deviated</span>
      </div>
      <div class="cvrg-summary-icon bg-rose">
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
  }
  <!-- Coverage % -->
  @for (d of tdyCoveredTrips; track d) {
  <div class="cvrg-summary-card cvrg-border-emerald">
    <div class="cvrg-card-body">
      <div class="cvrg-card-info">
        <div class="cvrg-summary-value">
          {{ d.coverage_per === null ? 0 : d.coverage_per }}%
        </div>
        <span class="cvrg-summary-label">Coverage %</span>
      </div>
      <div class="cvrg-summary-icon bg-emerald">
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
  }
  <!-- Total Distance -->
  <div class="cvrg-summary-card cvrg-border-teal">
    <div class="cvrg-card-body">
      <div class="cvrg-card-info">
        <div class="cvrg-summary-value">
          {{ dstCnt === null ? "0" : dstCnt }} Km
        </div>
        <span class="cvrg-summary-label">Total Distance</span>
      </div>
      <div class="cvrg-summary-icon bg-teal">
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</div>
}

<!-- Trip Data Grid Section -->
<div class="cvrg-section-card">
  <div class="cvrg-section-header">
    <div class="flex items-center gap-2">
      <div
        class="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg shadow-md flex items-center justify-center"
      >
        <svg
          class="w-4 h-4 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          ></path>
        </svg>
      </div>
      <h2 class="cvrg-section-title">
        Ward Secretariat wise Trip Coverage Status
      </h2>
    </div>
  </div>

  <div class="cvrg-grid-section">
    <app-data-grid
      id="gridContainer"
      style="width: 100%"
      [dataSource]="tripsData"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="Ward Secretariat wise Trip Coverage Status"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="false"
      scrollX="1610px"
    >
    </app-data-grid>
  </div>
</div>

<!-- Map Section -->
<div #pdfContent>
  <div class="cvrg-section-card cvrg-map-card">
    <div class="cvrg-section-header cvrg-map-header">
      <!-- Left: Checkboxes -->
      <div class="flex items-center gap-4">
        <label
          nz-checkbox
          [(ngModel)]="shwCvrge"
          (ngModelChange)="onChkCoverage($event)"
          class="cvrg-checkbox"
          >Coverage</label
        >
        <label
          nz-checkbox
          [(ngModel)]="shwplyback"
          (ngModelChange)="onChkPlyback($event)"
          class="cvrg-checkbox"
          >Playback</label
        >
      </div>

      <!-- Center: Title -->
      <div class="cvrg-map-title">
        @if (shwCvrge) {
        <h2 class="cvrg-section-title">Coverage of {{ slctdVehNm }}</h2>
        } @if (!shwCvrge) {
        <h2 class="cvrg-section-title">Playback of {{ slctdVehNm }}</h2>
        }
      </div>

      <!-- Right: Legend -->
      @if (shwCvrge) {
      <div class="cvrg-legend">
        <div class="cvrg-legend-item">
          <span class="cvrg-legend-dot cvrg-dot-green"></span>
          <span class="cvrg-legend-text">Covered Area</span>
        </div>
        <div class="cvrg-legend-item">
          <span class="cvrg-legend-dot cvrg-dot-red"></span>
          <span class="cvrg-legend-text">Not Covered Area</span>
        </div>
      </div>
      } @if (!shwCvrge) {
      <div class="cvrg-legend">
        <div class="cvrg-legend-item">
          <span class="cvrg-legend-dot cvrg-dot-green"></span>
          <span class="cvrg-legend-text">Schedule Route</span>
        </div>
        <div class="cvrg-legend-item">
          <span class="cvrg-legend-dot cvrg-dot-red"></span>
          <span class="cvrg-legend-text">Travelled Route</span>
        </div>
      </div>
      }
    </div>

    <div class="cvrg-map-body">
      <div id="map"></div>
    </div>
  </div>
</div>
